import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { EventKindDto, EventListItemDto, useCreateSourcingEventCopyMutation } from "../../autogen/bff-api";
import { useApiError } from "../../common/errors/useApiError";
import { urls } from "../../urls";
import { useCopyProcurement } from "./useCopyProcurement";

export const useCombinedEventRowActions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { triggerSoft } = useApiError();
  const [copyV1Event, { isLoading: isCopyingV1 }] = useCreateSourcingEventCopyMutation();
  const { copy: copyV2Event, isCopying: isCopyingV2 } = useCopyProcurement({ onError: triggerSoft });

  const copyEvent = async (event: EventListItemDto) => {
    if (event.kind === EventKindDto.V2) {
      await copyV2Event(event.id);
      return;
    }
    try {
      const copy = await copyV1Event({ eventId: event.id }).unwrap();
      navigate(urls.events.edit.go(copy.id).intro);
    } catch (e) {
      triggerSoft(e);
    }
  };

  return {
    copyEvent,
    isCopying: isCopyingV1 || isCopyingV2,
    copyDisabledReason: (event: EventListItemDto) =>
      event.canEdit ? undefined : t("Only admins and creators can copy events"),
  };
};
